import { useEffect, useRef } from 'react';

type Callback = (ev: MouseEvent) => void;

export function useOuterClick(
  callback: Callback,
  skipParentElementId?: string
) {
  const callbackRef = useRef<Callback>();
  const innerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
    function handleClick(e: MouseEvent) {
      const refCurrent: any = innerRef.current;
      if (refCurrent && callbackRef.current && !refCurrent.contains(e.target)) {
        if (skipParentElementId) {
          const parentElemnt = document.getElementById(skipParentElementId);
          if (parentElemnt && parentElemnt.contains(e.target as any)) {
            return;
          } else {
            callbackRef.current(e);
          }
        } else {
          callbackRef.current(e);
        }
      }
    }
  }, []);

  return innerRef;
}
